import React, { useState } from "react";
import { Ptag } from "components/core/fonts";
import styled from "styled-components";
import copy from "copy-to-clipboard";
import copyIcon from "assets/svgs/copy-icon.svg";
import { Box, IconButton } from "@mui/material";
import { CopyButton } from "./styles";

function ContactInfo({ label, children, isCopy }) {

  const [copiedStatus, setCopiedStatus] = useState(false);

  const handleCopyAnimate = () => {
    setCopiedStatus(true);
    setTimeout(() => setCopiedStatus(false), 2000);
  };

  const copyToClipboard = (value) => {
    copy(value);
  };

  return (
    <IndividualDiv>
      <Ptag fontSize="12px" fontWeight="400">
        {label}
      </Ptag>
      {isCopy ? (
        <CopyData>
          <Ptag
            fontSize="14px"
            marginTop="4px"
            fontWeight="700"
            marginRight="18px"
            color="#4a4a4a"
            style={{
              maxWidth: "95%",
              wordWrap: "break-word",
            }}
          >
            {children}
          </Ptag>
          <IconButton
            aria-label="copy"
            color="primary"
            style={{ padding: 0, marginTop: "4px" }}
          >
            <CopyButton
              className={copiedStatus ? "copied" : ""}
              onClick={handleCopyAnimate}
            >
              <img
                src={copyIcon}
                onClick={() => {
                  copyToClipboard(children);
                }}
              />
            </CopyButton>
          </IconButton>
        </CopyData>
      ) : (
        <Ptag
          fontSize="14px"
          fontWeight="700"
          marginTop="4px"
          color="#4a4a4a"
          style={{
            width: "70%",
            textWrap: "balance",
          }}
        >
          {children}
        </Ptag>
      )}
    </IndividualDiv>
  );
}

export default ContactInfo;

const CopyData = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  gap: 1rem;
  /* justify-content: space-between; */
  /* max-width: 60%; */
`;

const CopyImage = styled.img`
  cursor: pointer;
  margin-left: 40px;
`;

const IndividualDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 50px; */
`;
